/** @format */

import React, { memo } from "react";
import { NodeProps } from "react-flow-renderer";
import { TGroupNodeData } from "../utils/layout";
import { hexToRgba } from "../utils/people";

/** Riquadro colorato di una struttura: sta sotto linee e card e non intercetta il mouse. */
const GroupNodeComponent = ({ data }: NodeProps<TGroupNodeData>): JSX.Element => {
  const { structure, dimmed } = data;
  const textColor = structure.text_color || "#595959";

  return (
    <div
      className={`org-group${dimmed ? " org-group--dim" : ""}`}
      style={{
        backgroundColor: structure.background_color || "#fafafa",
        borderColor: hexToRgba(textColor, 0.35),
      }}
    >
      {structure.name && (
        <span className="org-group__label" style={{ color: textColor }}>
          {structure.name}
        </span>
      )}
    </div>
  );
};

export const GroupNode = memo(GroupNodeComponent);
GroupNode.displayName = "GroupNode";
